import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledContainer = styled.div`
  .button-screen {
	  padding: 2px;
	  text-align: left;
  }
  .button-screen.button-print {
	  @media print {
		display: none;
	  }
  }
`
/*
const StyledButton = styled.button`
  padding: 10px;
  border-radius: 4px;
  font-size: 10pt;
  font-weight: bold;
  cursor: pointer;
  background-color: ${props => props.buttonColor};
  border: ${props => '2px solid ' + props.buttonColor};
  color: ${props => props.textColor};
  :focus {
	  border: 3px solid #FF9900;
  }
*/

const StyledButton = styled.button`
  padding: 2px;
  border-radius: 4px;
  font-size: 9pt;
  font-weight: bold;
  cursor: pointer;
  white-space: normal;
  background-color: ${props => props.buttonColor};
  border: ${props => '2px solid ' + props.buttonColor};
  color: ${props => props.textColor};
  text-align: left;
  width: 100%;
  :focus {
	  border: 3px solid #FF9900 !important;
  }
  @media print {
	font-size: 6pt;
	padding: 2px;
	border-radius: 2px;
  }
`

/*
  @media print {
	font-size: 6pt;
	padding: 2px;
	border-radius: 2px;
	white-space: nowrap;
  }
*/

const StyledResetButton = styled.button`
  background-color: white;
  border: 2px solid #CCCCCC;
  padding: 2px;
  border-radius: 4px;
  font-size: 9pt;
  font-weight: bold;
  cursor: pointer;
  white-space: normal;
  text-align: left;
  width: 100%;
  :focus {
	  border: 3px solid #FF9900;
  }
`

const StyledImage = styled.img`
  padding: 0px;
  vertical-align: middle;
  height: 27px;
  width: 27px;
  float: left;
  @media print {
	height: 15px;
	width: 15px;
  }
`
/* 
  @media print {
	height: 15px;
	width: 15px;
  }
 */

const StyledLabelP = styled.p`
  overflow: hidden
`

const StyledLabelSpan = styled.span`
  height: 27px;
  display: flex;
  align-items: center;
  margin-left: 4px;
  @media print {
	height: 15px;
  }
`
export const RefreshButton = props => {
  const {color} = props
  const {button, text} = color
/* <style type="text/css" media="print">{"\ display: none;\ "}</style> */
  return (
    <StyledContainer>
    <div className="button-screen button-print">
      <StyledResetButton
        buttonColor={button}
        textColor={text}
		title="Toggle Display of Icons and Highlights"
        onClick={() => props.onClick(props)}
		onKeyDown={() => props.onKeyDown(props)}
		id="toggleAllButton"
      >
		Turn All Off
      </StyledResetButton>
	</div>
    </StyledContainer>
  )
}
export const EqStdButton = props => {
  const {color} = props
  const {button, text} = color
  const buttonTitle = "Click to toggle display of " + props.label
  const buttonId = "legendEqStdButton" + props.eqStd
  const buttonDivId = "legendEqStdDiv" + props.eqStd

  return (
    <StyledContainer>
    <div id="buttonDivId" className="button-screen">
      <StyledButton
        buttonColor={button}
        textColor={text}
		title={buttonTitle}
        onClick={() => props.onClick(props)}
		onKeyDown={() => props.onKeyDown(props)}
		id={buttonId}
      >
		<StyledImage src={props.url}/>
		<StyledLabelP><StyledLabelSpan>{props.label}</StyledLabelSpan></StyledLabelP>
      </StyledButton>
	</div>
    </StyledContainer>
  )
}

export const DepartmentButton = props => {
  const {color} = props
  const {button, text} = color
  const buttonTitle = "Click to toggle highlight of " + props.label
  const buttonId = "legendRmTypeButton" + props.rmType
  const buttonDivId = "legendRmTypeDiv" + props.rmType

  return (
    <StyledContainer>
    <div id="buttonDivId" className="button-screen">
      <StyledButton
        buttonColor={button}
        textColor={text}
		title={buttonTitle}
        onClick={() => props.onClick(props)}
		onKeyDown={() => props.onKeyDown(props)}
		id={buttonId}
      >
        {props.label}
      </StyledButton>
	</div>
    </StyledContainer>
  )
}
/* 
const DepartmentButton = props => {
  const {color} = props
  const {button, text} = color

  return (
    <StyledContainer>
      <StyledButton
        buttonColor={button}
        textColor={text}
        onClick={() => props.onClick(props)}
      >
        {props.label}
      </StyledButton>
    </StyledContainer>
  )
}
 */
DepartmentButton.propTypes = {
  label: PropTypes.string.isRequired
}

DepartmentButton.defaultProps = {
  color: {
    button: 'white',
    text: 'black'
  }
}

EqStdButton.propTypes = {
  label: PropTypes.string.isRequired
}

EqStdButton.defaultProps = {
  color: {
    button: '#CCCCCC',
    text: 'black'
  }
}

// export default DepartmentButton
